export default __webpack_public_path__ + "no_colored_language_attributes.png";